import React from "react"
import { CircularProgress, Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"

const useStyles = makeStyles(theme => ({
  root: {
    height: "calc(100vh - 144px)",
    width: "100%",
    [theme.breakpoints.down("xs")]: {
      height: "calc(100vh - 138px)",
    },
  },
}))
const Loading = () => {
  const classes = useStyles()

  return (
    <Grid
      container
      direction="row"
      justifyContent="center"
      alignItems="center"
      className={classes.root}
    >
      <Grid item>
        <CircularProgress className={classes.progress} />
      </Grid>
    </Grid>
  )
}

export default Loading
